<template>
  <div class="mt-20 text-center">
    <img
      class="my-15"
      :src="emptyStateImage"
      alt="No overtime policies"
      height="230"
    />

    <h4 class="my-0">No active overtime policies</h4>

    <p class="text-lighter mb-30 text-13">Set up automatic overtime policies</p>
  </div>
</template>
<script>
import { IMAGE_NO_OVERTIME_POLICIES } from '~/rails_assets';

export default {
  data: () => ({
    emptyStateImage: IMAGE_NO_OVERTIME_POLICIES,
  }),
};
</script>
